import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseScrapRulesProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    companyId?: string
  };
  mapper?: (data: any) => T,
};

export const useScrapRules = <T,>({
  filters: { search, page, companyId } = {},
  mapper = Mapper.default<T>(),
}: UseScrapRulesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['scrapRules', search, page, companyId],
    queryFn: () => {
      return privateAxios.get(`/maintenance/scrap_rules`, {
        params: {
          search,
          page,
          'q[company_id_eq]': companyId
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
